import React from "react";
import { useLocation } from "react-router-dom";

/**
 * Retorna uma instância de URLSearchParams baseada na query string da URL atual.
 *
 * @returns {URLSearchParams} Uma instância de URLSearchParams contendo os parâmetros da query string.
 *
 * @example
 * // Suponha que a URL atual seja: https://www.example.com/?param1=hello&param2=world
 * const query = useQuery();
 *
 * console.log(query.get('param1')); // Output: "hello"
 * console.log(query.get('param2')); // Output: "world"
 */
const useQuery = (): URLSearchParams => {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
};

export default useQuery;
